var map = {
	"./icon_0.png": "36f1",
	"./icon_1.png": "cc4b",
	"./icon_2.png": "fa00",
	"./icon_3.png": "dea8",
	"./icon_4.png": "11d3",
	"./icon_5.png": "ba2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7275";